import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </M>
  );
};

export const LineReveal = ({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClassName}`}
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delay + i * stagger, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <p className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.28em] ${light ? "text-gold" : "text-gold-ink"} ${className}`}>
    <span className={`h-px w-8 ${light ? "bg-gold" : "bg-gold"}`} />
    {children}
  </p>
);
